import Button from '../components/Button';
import Icon from '../components/Icon';
import type { ImageUrls } from '../types/news';

type Props = {
  imageUrls: ImageUrls | null;
  imageUploading: boolean;
  onUpload: (file: File) => void;
};

export default function TeamImageSection({
  imageUrls,
  imageUploading,
  onUpload,
}: Props) {
  function triggerFilePicker() {
    (document.getElementById('team-image-upload') as HTMLInputElement)?.click();
  }

  return (
    <div className="border border-gray-tint-6 rounded-_20 padding-3 w-full">
      <h3 className="margin-bottom-5">Bild</h3>

      {imageUrls ? (
        <div className="flex flex-col gap-2">
          <div className="image-preview-box">
            <img src={imageUrls.medium} alt="Teammitglied Bild" />
          </div>

          <Button iconName="icon-photo-landscape" onClick={triggerFilePicker}>
            Bild ersetzen
          </Button>
        </div>
      ) : (
        <div className="border border-gray-tint-7 rounded-3 padding-3 flex flex-col items-center justify-center gap-2">
          <p className="margin-bottom-0_5 text-center">
            {imageUploading ? 'Wird hochgeladen…' : 'Kein Bild hochgeladen'}
          </p>

          <Icon name="icon-upload" size={2} />

          {!imageUploading && (
            <Button iconName="icon-photo-landscape" onClick={triggerFilePicker}>
              Bild hochladen
            </Button>
          )}
        </div>
      )}

      <input
        id="team-image-upload"
        type="file"
        accept="image/*"
        className="hidden"
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) onUpload(file);
        }}
      />
    </div>
  );
}
